import { TransactionsType } from 'app/dataTypes/cafeteria/compensation/transactions'
import { Column } from '../columns'
import { getOperationType } from './operationType'
import { getStatusColor } from './statusColors'


type Props = {
  transaction: TransactionsType
  columnKey: Column
}

export const Cell = ({ transaction, columnKey }: Props) => {
  const { date, value, operationType, comment } = transaction
  const color = getStatusColor(operationType)

  if (columnKey === Column.Date) {
    return <div>{date.getString('YYYY.MM.DD')}</div>
  }

  if (columnKey === Column.Value) {
    return <div style={{ color }}>{value}</div>
  }

  if (columnKey === Column.OperationType) {
    return <div>{getOperationType(operationType)}</div>
  }

  if (columnKey === Column.Comment) {
    return <div>{comment}</div>
  }

  return <div>{'—'}</div>
}
